<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('tracking.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('tracking.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <a-tabs :default-active-key="key" @change="onTableChange">
        <a-tab-pane :key="1" :tab="$t('tracking.historyPath')" force-render>
          <locationPath ref="location" v-if="key === 1"/>
        </a-tab-pane>
        <a-tab-pane :key="2" :tab="$t('tracking.nearest')">
          <nearest v-if="key === 2"/>
        </a-tab-pane>
        <a-tab-pane :key="3" :tab="$t('tracking.visitHistory')">
          <viewHistory v-if="key === 3"/>
        </a-tab-pane>
      </a-tabs>
    </ts-card>
  </div>
</template>
<script>
import locationPath from './components/location-path.vue'
import nearest from './components/nearest.vue'
import viewHistory from './components/viewHistory.vue'
export default {
  name: 'locationTracking',
  components: {
    locationPath,
    nearest,
    viewHistory
  },
  data() {
    return {
      loading: false,
      key: 1,
      employees: []
    }
  },
  methods: {
    onTableChange(key) {
      this.key = key
    }
  }
}
</script>
